import { useState } from "react";
import { createCollection } from "./Collection.es.js";
function useListState(props) {
  const [focusedKey, setFocusedKey] = useState(null);
  const collection = createCollection(props.options);
  const selectedIndex = Array.from(collection.index.values()).findIndex(
    (item) => item.value === props.value
  );
  return {
    collection,
    selectionManager: {
      focusedKey,
      setFocusedKey,
      selectedKey: selectedIndex < 0 ? null : selectedIndex,
      replaceSelection: props.onSelectionChange
    }
  };
}
export {
  useListState
};
//# sourceMappingURL=useListState.es.js.map
